export const getTodayDate = () => {
  const today = new Date();
  const date = today.toLocaleDateString('en-GB');
  const splitDate = date.split('/');
  return `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
};

export const getOneMonthFromTodayDate = () => {
  const today = new Date();
  today.setMonth(today.getMonth() + 1);
  const date = today.toLocaleDateString('en-GB');
  const splitDate = date.split('/');
  return `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
};

export const createSearchURLFromOptions = (locale, optionsSelected, city) => {
  const SEARCH_URL =
    locale === 'en'
      ? `https://www.spotahome.com/s/${city}`
      : `https://www.spotahome.com/${locale}/s/${city}`;

  const queryParams =
    optionsSelected &&
    optionsSelected.reduce((prevVal, currVal, currIndex) => {
      if (currIndex === 0) return `${currVal}?`;
      if (currIndex + 1 !== optionsSelected.length)
        return `${prevVal}${currVal}&`;
      return `${prevVal}${currVal}`;
    }, '');

  return `${SEARCH_URL}/${queryParams}&utm_campaign=spottyCatCTA`;
};

const FEATURED_CITIES = ['madrid', 'berlin', 'brussels', 'barcelona', 'milan'];

export const getFormattedCities = cityList =>
  cityList.map(city => city.cityName);

export const getFeaturedCitiesFormatted = cityList =>
  cityList
    .filter(item => FEATURED_CITIES.includes(item.cityId))
    .map(item => item.cityName);
